/**
 * Makes value nullable. Used to fix incorrect GraphQL types which uses @include or @skip directives
 * @param value
 */
export function nullable<T>(value: T | undefined): T | undefined {
  return value;
}
